<template>
  <div class="invoice-wrap">
    <div class="block invoice-form">
      <a-form
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-item label="发票类型">
          <a-input
            placeholder="请输入发票类型"
            v-decorator="[
              'iType',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            readOnly
            size="large"
          />
        </a-form-item>
        <a-form-item label="发票抬头">
          <a-input
            :placeholder="`请输入${type === 0 ? '姓名' : 'XXX公司'}`"
            v-decorator="[
              'invoiceTitle',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            size="large"
          />
        </a-form-item>
        <a-form-item label="纳税人识别号" v-if="type === 1">
          <a-input
            placeholder="请输入纳税人识别号"
            v-decorator="[
              'taxpayerIdentity',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            size="large"
          />
        </a-form-item>
        <a-form-item label="开票项目">
          <a-input
            placeholder="请输入开票项目"
            v-decorator="[
              'project',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            readOnly
            size="large"
          />
        </a-form-item>
        <a-form-item label="开票金额">
          <a-input
            placeholder="请输入开票金额"
            v-decorator="[
              'price',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            readOnly
            size="large"
          />
        </a-form-item>
        <a-form-item label="邮箱地址">
          <a-input
            placeholder="请输入邮箱地址"
            v-decorator="[
              'email',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            size="large"
          />
        </a-form-item>
        <a-form-item label="手机号码">
          <a-input
            placeholder="请输入手机号码"
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            size="large"
          />
        </a-form-item>
        <a-form-item label="发票备注">
          <a-textarea
            placeholder="您输入的备注信息会打印在发票备注栏。"
            v-decorator="[
              'invoiceContent',
              {
                rules: [
                  {
                    validator: handleFieldValidate,
                  },
                ],
                validateTrigger: 'blur',
              },
            ]"
            size="large"
          />
        </a-form-item>
        <a-form-item label :wrapper-col="{ span: 16, offset: 6 }">
          <a-button
            type="primary"
            class="submit-btn"
            size="large"
            :loading="loading"
            @click="formSubmit"
            >确认</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <div
      class="block invoice-notice"
      v-if="invoiceBookTips"
      v-html="invoiceBookTips"
    ></div>
  </div>
</template>
<script>
import { validate } from '@/assets/js/validate'
import { invoicing } from '@/apis/invoice'

export default {
  props: {
    type: Number,
    invoiceBookTips: String,
    initData: Object
  },
  data () {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  mounted () {
    const { project, price } = this.initData
    this.$nextTick(() => {
      this.form.setFieldsValue({
        iType: `${this.type === 0 ? '个人' : '企业'}电子发票`,
        project,
        price: `${price}元`
      })
    })
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      validate('invoice-book', formValues, rule.fullField).then(
        ({ valid, errors }) => {
          if (valid) {
            callback()
          } else {
            callback(errors[0].message)
          }
        }
      )
    },
    formSubmit () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true
          try {
            const params = {
              extraId: this.initData.extraId,
              orderNo: this.initData.orderNo,
              invoiceType: this.type,
              ...values,
              price: this.initData.price,
              detailId: this.initData.detailId,
              airportTax: this.initData.airportTax
            }

            delete params.iType

            await invoicing(params)
            this.$emit('success')
            this.loading = false
          } catch (err) {
            this.loading = false
            this.$message.error(err.message || '开票失败，请稍后再试')
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-wrap {
  display: flex;
  .block {
    padding: 0 40px;
    width: 50%;
  }
  .invoice-form {
    border-right: 1px solid #eee;
  }
  .submit-btn.ant-btn {
    width: 100%;
  }
}
</style>
